import React, { useEffect } from "react";
import { inject } from "mobx-react";
import Header from "./common/header";
import Progress from "./common/progress";
import Problem from "./items/problem";
import Questions from "./items/questions";
import Details from "./items/details";
import Availability from "./items/availability";
import Review from "./items/review";
import Submitted from "./items/submited";
import "./index.less";
import { ProgressBusiness, } from "@business/newCreateRequest/common/progress";
import { AmplitudeEventName, PredefinedWoType, ProblemLevel, StepType } from "@common/enums/base";
import { observer } from "mobx-react-lite";
import { combine } from "fe-toolkit";
import DuplicateOriginWOSubmitted from "./items/problem/duplicateCheck/OriginWOSubmitted";
import { getCurrentEnv, isEmpty, sendAmplitude_Default } from "@common/utils";
import { stepReviewBusiness } from "@business/newCreateRequest/stepsItems/review";
import Cookies from "js-cookie";
var RecallCheck = ProblemLevel.RecallCheck, DuplicateCheck = ProblemLevel.DuplicateCheck;
var createIndex = inject(combine(ProgressBusiness, stepReviewBusiness))(observer(function (props) {
    var duplicateWOList = props.duplicateWOList, currentStep = props.currentStep, initAll = props.initAll, step = props.step, level = props.level, back = props.back, history = props.history, setLevel = props.setLevel, currentUser = props.currentUser, recallWOList = props.recallWOList, progressLastLevel = props.progressLastLevel, woTypeId = props.woTypeId, serviceCodeWOType = props.serviceCodeWOType, setHowToVideoVisibleProgress = props.setHowToVideoVisibleProgress;
    useEffect(function () {
        initAll();
    }, []);
    var sendAmplitude = function () {
        sendAmplitude_Default(AmplitudeEventName.NewRSP_Browser_Back, {
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            currentStep: "Problem",
            currentLevel: level,
            clientId: Cookies.get('clientId'),
            env: getCurrentEnv(),
        });
    };
    var detailStepBackHandle = function () {
        switch (level) {
            case ProblemLevel.DifferentIssue:
                if (!isEmpty(recallWOList))
                    setLevel(RecallCheck);
                else if (!isEmpty(duplicateWOList))
                    setLevel(DuplicateCheck);
                else
                    setLevel(progressLastLevel);
                break;
            default:
                setLevel(level - 1);
        }
        back();
    };
    var browserBack = function (e) {
        setHowToVideoVisibleProgress(false);
        switch (step) {
            case StepType.Submitted:
                history.push({ pathname: '/?isFromNewRequestSubmitted=true' });
                break;
            case StepType.Review:
                window.history.pushState(null, null, document.URL);
                back();
                break;
            case StepType.DuplicateOriginWOSubmitted:
                history.push({ pathname: '/' });
                break;
            case StepType.Detail:
                detailStepBackHandle();
                break;
            case StepType.Problem:
                switch (level) {
                    case ProblemLevel.LevelOne:
                        sendAmplitude();
                        history.push({ pathname: '/' });
                        break;
                    case ProblemLevel.LevelTwo:
                    case ProblemLevel.LevelThree:
                        sendAmplitude();
                        setLevel(level - 1);
                        break;
                    case ProblemLevel.DuplicateCheck:
                        if (isResidentResponsibilityCount()) {
                            setLevel(ProblemLevel.ResidentResponsiBility);
                        }
                        else {
                            setLevel(progressLastLevel);
                        }
                        break;
                    case ProblemLevel.ResidentResponsiBility:
                        setLevel(progressLastLevel);
                        break;
                    case ProblemLevel.RecallCheck:
                        if (!isEmpty(duplicateWOList)) {
                            setLevel(ProblemLevel.DuplicateCheck);
                            break;
                        }
                        if (isResidentResponsibilityCount()) {
                            setLevel(ProblemLevel.ResidentResponsiBility);
                            break;
                        }
                        setLevel(progressLastLevel);
                        break;
                    case ProblemLevel.HowToVideo:
                        if (!isEmpty(recallWOList)) {
                            setLevel(ProblemLevel.RecallCheck);
                            break;
                        }
                        if (!isEmpty(duplicateWOList)) {
                            setLevel(ProblemLevel.DuplicateCheck);
                            break;
                        }
                        if (isResidentResponsibilityCount()) {
                            setLevel(ProblemLevel.ResidentResponsiBility);
                            break;
                        }
                        setLevel(progressLastLevel);
                        break;
                    default:
                        setLevel(level - 1);
                }
                break;
            default:
                back();
        }
    };
    var isResidentResponsibilityCount = function () {
        return Cookies.get("residentResponsibilityCount") === 'true' &&
            (woTypeId ? woTypeId : serviceCodeWOType) === PredefinedWoType.ResidentResponsibility;
    };
    useEffect(function () {
        window.history.pushState(null, null, document.URL);
        window.addEventListener('popstate', browserBack);
        return function () {
            window.removeEventListener('popstate', browserBack);
        };
    }, [step, level, progressLastLevel, duplicateWOList]);
    return React.createElement("div", { className: "rsp-body" },
        (currentStep != StepType.Submitted && currentStep != StepType.DuplicateOriginWOSubmitted) && React.createElement(React.Fragment, null,
            React.createElement(Header, null),
            level !== ProblemLevel.HowToVideo && React.createElement(Progress, null),
            React.createElement("div", null,
                currentStep === StepType.Problem && React.createElement(Problem, null),
                currentStep === StepType.Detail && React.createElement(Details, null),
                currentStep === StepType.Question && React.createElement(Questions, null),
                currentStep === StepType.Availability && React.createElement(Availability, null),
                currentStep === StepType.Review && React.createElement(Review, null))),
        currentStep === StepType.Submitted && React.createElement(Submitted, null),
        currentStep === StepType.DuplicateOriginWOSubmitted && React.createElement(DuplicateOriginWOSubmitted, null));
}));
export default createIndex;
